import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Profile.css";

const Profile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const openDropdown = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };


  const closeDropdown = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handleOrdersClick = () => {
    // const orders = JSON.parse(localStorage.getItem("orders")) || [];
    setIsOpen(false);
    navigate("/order");
  };

  const handleWishlistClick = () => {
    setIsOpen(false);
    navigate("/wishlist");
  };

  const handleSavedAddressClick = () => {
    setIsOpen(false);
    navigate("/saved-address"); // change to your actual route if needed
  };
  
  const handleMyaccountClick = () => {
    setIsOpen(false);
    navigate("/myaccount"); // change to your actual route if needed
  };

  return (
    <div
      className="profile-container nav-icons"
      onMouseEnter={openDropdown}
      onMouseLeave={closeDropdown}
      onClick={() => setIsOpen(prev => !prev)}
    >
      <img src='/assets/profile.png' alt='profile' className='icon-image'/>
      <span>Profile</span>

      {isOpen && (
        <div 
          className="profile-dropdown"
          onMouseEnter={openDropdown}
          onMouseLeave={closeDropdown}
        >
          <div className="dropdown-item" onClick={handleOrdersClick}>
            📦 <span>Orders</span>
          </div>
          <div className="dropdown-item" onClick={handleSavedAddressClick}>
            📍 <span>Saved Address</span>
          </div>
          <div className="dropdown-item" onClick={handleWishlistClick}>
            ❤️ <span>Wishlist</span>
          </div>
          <div className="dropdown-item" onClick={handleMyaccountClick}>
            📦 <span>My account</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;

